module.exports = __webpack_public_path__ + "img/generate-01.04ec4c95.png";